(function ($) {

    'use strict';

    // 库存倒计时组件
    class StockCountdown extends HTMLElement {
        constructor() {
            super();

            // 创建一个 shadow root，给指定的元素挂载一个 Shadow DOM，并且返回对 ShadowRoot 的引用
            this.attachShadow({ mode: 'open' });

            this.render();
        }

        // 获取组件属性
        static get observedAttributes() {
            return ['total', 'stock','tip','tip-title','tip-color', 'bar-color', 'bar-bg-color','direction','wrap-class','pc-style','mobile-style','width','height','mobile-height'];
        }

        // 总数量
        get total() {
            return Number(this.getAttribute('total') || '1');
        }

        // 库存量
        get stock() {
          const stock=Number(this.getAttribute('stock') || '0')
          return stock > this.total ? 0:stock;
        }

        // 提示文案
        get tip() {
          return this.getAttribute('tip') || ''
        }

        // 提示文案的title
        get tipTitle() {
          return this.getAttribute('tip-title') || ''
        }
        

        // 提示文案的颜色
        get tipColor() {
          return this.getAttribute('tip-color') || "#fff"
        }

        // 进度条颜色
        get barColor() {
          return this.getAttribute('bar-color') || '#FEC010'
        }

        // 进度条背景色
        get barBgColor() {
          return this.getAttribute('bar-bg-color') || '#fff'
        }

        // 方向
        get direction() {
          return this.getAttribute('direction') || 'row';
        }
        // pc样式
        get pcStyle() {
          return this.getAttribute('pc-style') || '';
        }
        // 手机端样式
        get mobileStyle() {
          return this.getAttribute('mobile-style') || '';
        }

        // 宽度
        get width(){
          return this.getAttribute('width') || '84';
        }

        // 高度
        get height(){
          return this.getAttribute('height') || '4';
        }
        // 手机端高度
        get mobileHeight(){
          return this.getAttribute('mobile-height') || '4';
        }

        attributeChangedCallback(name, oldValue, newValue) {
          if (oldValue !== newValue) {
            this.render();
          }
        }
      
    
  
        render() {
          const height = /[0-9]$/.test(this.height) ? `${this.height}px`:this.height;
          const mobileHeight = /[0-9]$/.test(this.mobileHeight) ? `${this.mobileHeight}px`:this.mobileHeight;
          // 样式
          const style = `
            <style>
              .stock-countdown-range-wrap {
                display: flex;
                flex-direction: ${this.direction};
                align-items: ${this.direction.includes('column') ? 'flex-start':'center'};
                overflow: hidden;
              }
              .stock-countdown-range {
                width: ${/[0-9]$/.test(this.width) ? `${this.width}px`:this.width};
                height: ${height};
                margin-right:8px;
                background-color: #FFFFFF;
                border-radius: ${height};
                vertical-align: top;
              }
              .stock-countdown-progress {
                background-color: #FEC010;
                border-radius: ${height};
                height: 100%;
              }
              .stock-countdown-title {
                line-height: 20px;
                font-size: 14px;
                color: #FFFFFF;
                vertical-align: top;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                flex: 1;
              }
              ${this.pcStyle}
              @media (max-width: 768px) {
                .stock-countdown-range-wrap {
                  flex-direction: ${this.direction.includes('column') ? 'column':'column-reverse'};
                  align-items: flex-start;
                }
                .stock-countdown-range {
                  width: 100%;
                  height: 6px;
                  margin: 4px 0 6px 0;
                }
                .product-stock-countdown {
                  margin-top: 7px;
                }
                .stock-countdown-title {
                  line-height: 18px;
                  font-size: 12px;
                }
                ${this.mobileStyle}
              }
            </style>
          `;
          // 提示文案
          const tip=`
          <span class="stock-countdown-title" style="color:${this.tipColor}" title="${this.tipTitle}">
            ${this.tip}
          </span>
          `

          const classValue = this.getAttribute('wrap-class') || '';
          // 模板
          const template = `
          <div class="stock-countdown-range-wrap ${classValue}">
              <div class="stock-countdown-range" style="background-color: ${this.barBgColor}">
                <div class="stock-countdown-progress" style="width: ${(this.stock/this.total * 100).toFixed(0)}%;background-color:${this.barColor}"></div>
              </div>
              ${this.tip ? tip:''}
          </div>
          `;
          // 向 shadow root 上挂载样式、模板
          this.shadowRoot.innerHTML = `${style}${template}`;
        }
    }

    theme.AssetsLoader.onPageLoaded(function () {
        customElements.define('stock-countdown', StockCountdown);
    });

})(jQueryTheme);